.main {
	min-width: 80svw;
}

@media (max-width: 540) {
	.main {
		min-width: 100vw;
	}
}

.seperatorLineTop {
	margin-bottom: 20px !important;
}

.seperatorLine {
	margin-top: 20px !important;
	margin-bottom: 20px !important;
}

.iconSize {
	font-size: 64px !important;
}

.menuContainerPapaer {
	width: 100% !important;
	height: 170px !important;
	text-align: center !important;
}

.alIcon {
	font-size: 64px !important;
}
